export default __webpack_public_path__ + "static/media/HASSAN_FR_SEQ12.44e3004e.mp3";